var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProdukty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.356,49.844C40.884,49.844 41.312,50.273 41.313,50.801L41.323,62.657C41.323,63.186 40.895,63.614 40.366,63.614C39.838,63.614 39.41,63.186 39.41,62.657L39.399,50.802C39.399,50.273 39.828,49.844 40.356,49.844Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.44,48.66C35.897,48.925 36.054,49.509 35.791,49.966L29.871,60.24C29.607,60.698 29.021,60.855 28.564,60.59C28.106,60.326 27.95,59.741 28.213,59.283L34.133,49.011C34.397,48.553 34.982,48.396 35.44,48.66Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.78,45.187C32.045,45.644 31.888,46.229 31.431,46.494L21.168,52.431C20.71,52.695 20.125,52.539 19.861,52.081C19.597,51.623 19.754,51.038 20.211,50.774L30.473,44.837C30.93,44.573 31.516,44.729 31.78,45.187Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.342,40.358C30.342,40.886 29.913,41.315 29.386,41.315L17.529,41.325C17,41.325 16.572,40.897 16.572,40.369C16.572,39.84 17,39.412 17.529,39.412L29.384,39.402C29.913,39.401 30.342,39.83 30.342,40.358Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52,35.455C31.256,35.913 30.671,36.07 30.214,35.806L19.94,29.886C19.483,29.622 19.326,29.037 19.59,28.58C19.854,28.122 20.439,27.965 20.897,28.229L31.169,34.148C31.627,34.412 31.784,34.997 31.52,35.455Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.994,31.789C34.537,32.054 33.952,31.897 33.687,31.44L27.75,21.177C27.486,20.719 27.643,20.134 28.1,19.87C28.558,19.605 29.144,19.762 29.407,20.22L35.344,30.482C35.608,30.939 35.452,31.525 34.994,31.789Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.832,30.343C39.304,30.343 38.876,29.915 38.875,29.387L38.865,17.531C38.865,17.002 39.293,16.574 39.821,16.574C40.35,16.574 40.778,17.002 40.778,17.531L40.788,29.386C40.789,29.914 40.36,30.343 39.832,30.343Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.743,31.513C44.286,31.249 44.129,30.665 44.393,30.207L50.312,19.934C50.576,19.476 51.162,19.319 51.619,19.583C52.077,19.848 52.234,20.433 51.97,20.891L46.051,31.163C45.786,31.621 45.201,31.778 44.743,31.513Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.409,34.988C48.145,34.531 48.301,33.946 48.759,33.682L59.022,27.745C59.48,27.481 60.065,27.637 60.329,28.095C60.593,28.553 60.436,29.138 59.979,29.401L49.717,35.338C49.259,35.603 48.673,35.446 48.409,34.988Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.843,39.826C49.843,39.298 50.271,38.87 50.799,38.87L62.656,38.859C63.184,38.859 63.613,39.287 63.613,39.816C63.613,40.344 63.184,40.773 62.656,40.773L50.801,40.783C50.272,40.784 49.843,40.355 49.843,39.826Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.666,44.76C48.93,44.303 49.515,44.146 49.972,44.41L60.245,50.329C60.703,50.593 60.86,51.179 60.596,51.636C60.332,52.094 59.746,52.25 59.289,51.987L49.017,46.068C48.559,45.803 48.402,45.218 48.666,44.76Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.193,48.403C45.65,48.139 46.235,48.295 46.5,48.752L52.437,59.015C52.701,59.473 52.544,60.058 52.087,60.323C51.629,60.587 51.043,60.43 50.78,59.972L44.843,49.711C44.579,49.253 44.735,48.667 45.193,48.403Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.067,53.706C44.574,53.56 45.104,53.854 45.249,54.362L47.314,61.534C47.459,62.042 47.165,62.572 46.657,62.717C46.149,62.863 45.619,62.569 45.474,62.06L43.41,54.889C43.265,54.381 43.559,53.851 44.067,53.706Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,53.869C37.243,53.997 37.555,54.516 37.427,55.029L35.628,62.272C35.5,62.784 34.98,63.096 34.468,62.968C33.955,62.84 33.643,62.32 33.772,61.808L35.57,54.565C35.698,54.052 36.218,53.741 36.73,53.869Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.293,50.342C30.672,50.709 30.683,51.315 30.315,51.695L25.136,57.068C24.769,57.448 24.163,57.458 23.783,57.091C23.404,56.724 23.393,56.118 23.761,55.738L28.94,50.365C29.307,49.985 29.913,49.975 30.293,50.342Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.491,44.061C26.636,44.569 26.343,45.099 25.835,45.244L18.663,47.308C18.155,47.453 17.626,47.159 17.48,46.651C17.334,46.143 17.628,45.613 18.137,45.468L25.308,43.404C25.816,43.259 26.346,43.553 26.491,44.061Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.328,36.74C26.2,37.252 25.68,37.564 25.168,37.436L17.924,35.637C17.412,35.509 17.1,34.99 17.229,34.477C17.357,33.965 17.876,33.653 18.389,33.781L25.631,35.58C26.144,35.708 26.456,36.227 26.328,36.74Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.853,30.308C29.486,30.688 28.88,30.698 28.5,30.331L23.127,25.152C22.747,24.785 22.737,24.179 23.104,23.799C23.472,23.419 24.078,23.409 24.457,23.776L29.831,28.955C30.21,29.322 30.221,29.928 29.853,30.308Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.121,26.478C35.613,26.623 35.083,26.33 34.938,25.822L32.874,18.65C32.728,18.142 33.022,17.612 33.53,17.466C34.038,17.321 34.568,17.615 34.714,18.124L36.777,25.295C36.922,25.803 36.628,26.333 36.121,26.478Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.456,26.33C42.944,26.202 42.632,25.682 42.76,25.17L44.559,17.927C44.687,17.414 45.206,17.102 45.719,17.231C46.231,17.359 46.543,17.878 46.415,18.391L44.616,25.633C44.488,26.146 43.969,26.458 43.456,26.33Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.892,29.84C49.513,29.473 49.502,28.867 49.87,28.488L55.048,23.114C55.416,22.735 56.022,22.724 56.401,23.091C56.781,23.459 56.792,24.065 56.424,24.444L51.245,29.818C50.878,30.197 50.272,30.208 49.892,29.84Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.697,36.122C53.551,35.614 53.846,35.085 54.353,34.939L61.525,32.875C62.033,32.73 62.563,33.024 62.709,33.532C62.854,34.04 62.56,34.57 62.051,34.715L54.88,36.779C54.372,36.924 53.842,36.63 53.697,36.122Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86,43.465C53.988,42.953 54.507,42.641 55.02,42.769L62.263,44.568C62.775,44.696 63.087,45.215 62.959,45.728C62.831,46.24 62.311,46.552 61.799,46.424L54.556,44.625C54.043,44.497 53.732,43.978 53.86,43.465Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.333,49.88C50.7,49.501 51.306,49.49 51.686,49.857L57.059,55.036C57.439,55.404 57.449,56.01 57.082,56.389C56.715,56.769 56.109,56.78 55.729,56.412L50.356,51.233C49.976,50.866 49.966,50.26 50.333,49.88Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,40C79.5,18.199 61.801,0.5 40,0.5C18.199,0.5 0.5,18.199 0.5,40C0.5,61.801 18.199,79.5 40,79.5C61.801,79.5 79.5,61.801 79.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdukty);
export default __webpack_public_path__ + "static/media/produkty.2189c0af.svg";
export { ForwardRef as ReactComponent };